__turbopack_context__.v({
  "root": "index-module__fc_4Ua__root",
  "section": "index-module__fc_4Ua__section",
});
